// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b84fb400","140":"c678d566","248":"365aa605","292":"a15423ec","476":"d4d034ca","560":"60cb2e1d","592":"d3ad333e","652":"b0de4a54","760":"e4b0813f","764":"5f4e40a3","776":"3c4d042e","796":"03901bf9","816":"07cd4310","896":"9fed316f","907":"9ccb6169","956":"245782e9"}[chunkId] + ".chunk.js";
};